import { CSSProperties, RefObject, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Tooltip.module.css';

interface TooltipProps {
  children: React.ReactNode;
  visible: boolean;
  year: number | null;
  tooltipPosition?: { left: number } | null;
  tableRef?: RefObject<HTMLTableElement | null>;
}

const SAFE_HORIZONTAL_MARGIN = 40;

const Tooltip = ({ children, visible, year, tooltipPosition, tableRef }: TooltipProps) => {
  const [safeTooltipMargin, setSafeTooltipMargin] = useState<number>();

  const tooltipRef = useRef<HTMLDivElement>(null);

  const el = document.getElementById('tooltip-root');

  const positionStyle = useMemo<CSSProperties>(
    () => ({
      top: '-5rem',
      left: tooltipPosition && safeTooltipMargin !== undefined ? tooltipPosition.left - safeTooltipMargin || 0 : 0,
    }),
    [safeTooltipMargin, tooltipPosition],
  );

  useEffect(() => {
    const computeTooltipPosition = () => {
      setTimeout(() => {
        if (!tableRef?.current || !tooltipRef?.current || !el || !visible || !year) return;
        const tableRightOffset = tableRef.current.getBoundingClientRect().right;
        const tooltipLeftOffset = tooltipRef.current.getBoundingClientRect().right;
        setSafeTooltipMargin(tableRightOffset - tooltipLeftOffset < 40 ? SAFE_HORIZONTAL_MARGIN : 0);
      }, 100);
    };
    computeTooltipPosition();
  }, [el, tableRef, tooltipPosition?.left, tooltipRef, visible, year]);

  if (!visible || !el) return null;

  return createPortal(
    <div ref={tooltipRef} className={styles.tooltip} style={positionStyle}>
      {children}
    </div>,
    el,
  );
};

export default Tooltip;
